/* ============================================================
   MINERAL POWDER NAVIGATOR
   - Render: custom_liquid_bHQm4A içinde, variant_picker'dan sonra
   - JS: navigator'ü DOM'da variant_picker'ın önüne taşır
   - AJAX section swap + verbose logging (console'dan teşhis için)
   ============================================================ */

(function () {
  'use strict';

  const FINISH_ORDER = ['Matte', 'Satin', 'Shimmery'];
  const MAIN_SECTION_ID = 'shopify-section-main';
  const LOG = '[mp-nav]';

  let currentAbort = null;
  let cachedPowders = null;

  /* ---------- INIT ---------- */
  function initAll() {
    document.querySelectorAll('[data-mp-nav]').forEach(root => {
      if (root.dataset.mpInited === '1') return;
      root.dataset.mpInited = '1';
      console.log(LOG, 'initNav', root);
      initNav(root);
      // Reposition'ı her zaman dene; başarısız olursa MutationObserver kuyrukla
      tryReposition(root);
    });
  }

  /* ---------- REPOSITION ---------- */
  function tryReposition(nav) {
    if (repositionNav(nav)) return;
    // İlk denemede başarısız: variant_picker DOM'u henüz hazır değil olabilir
    console.log(LOG, 'reposition başarısız, MutationObserver başlatılıyor');
    const section = document.getElementById(MAIN_SECTION_ID);
    if (!section) return;

    const obs = new MutationObserver(() => {
      if (repositionNav(nav)) {
        obs.disconnect();
        console.log(LOG, 'MutationObserver ile reposition başarılı');
      }
    });
    obs.observe(section, { childList: true, subtree: true });

    // 5 saniyeden sonra vazgeç
    setTimeout(() => obs.disconnect(), 5000);
  }

  function repositionNav(nav) {
    if (nav.dataset.mpPositioned === '1') return true;

    // Strateji 1: variant_picker block'unu CSS selectorlerle ara
    const blockSelectors = [
      '[data-block-type="variant_picker"]',
      '[data-block-id*="variant_picker"]',
      '[id*="variant_picker"]',
      '[class*="variant_picker"]',
      '[class*="variant-picker"]',
      '.product__variants'
    ];

    let variantWrapper = null;
    for (const sel of blockSelectors) {
      const el = document.querySelector(sel);
      if (el && !nav.contains(el) && !el.contains(nav)) {
        variantWrapper = el;
        console.log(LOG, 'variantWrapper bulundu (selector):', sel, el);
        break;
      }
    }

    // Strateji 2: input[name="id"]'den walk-up
    if (!variantWrapper) {
      const idInput = Array.from(document.querySelectorAll('input[name="id"]'))
        .find(i => !nav.contains(i));
      if (idInput) {
        console.log(LOG, 'idInput bulundu:', idInput);
        const navWrapper = nav.parentElement;
        const blockParent = navWrapper && navWrapper.parentElement;
        if (blockParent) {
          let candidate = idInput;
          while (candidate && candidate.parentElement !== blockParent) {
            candidate = candidate.parentElement;
            if (!candidate || candidate === document.body || candidate === document.documentElement) {
              candidate = null;
              break;
            }
          }
          if (candidate && candidate !== navWrapper) {
            variantWrapper = candidate;
            console.log(LOG, 'variantWrapper bulundu (walk-up):', candidate);
          }
        }
      }
    }

    if (!variantWrapper) {
      console.warn(LOG, 'variant_picker bulunamadı, nav yerinde kalıyor');
      return false;
    }

    // Taşı
    variantWrapper.parentElement.insertBefore(nav, variantWrapper);
    nav.dataset.mpPositioned = '1';
    console.log(LOG, 'nav variant_picker önüne taşındı ✓');
    return true;
  }

  /* ---------- NAVIGATOR CASCADE ---------- */
  function initNav(root) {
    const dataEl = root.querySelector('[data-mp-data]');
    if (!dataEl) {
      console.warn(LOG, 'data blob bulunamadı');
      return;
    }

    let POWDERS;
    try {
      POWDERS = JSON.parse(dataEl.textContent);
      cachedPowders = POWDERS;
    } catch (err) {
      console.error(LOG, 'data parse hatası', err);
      return;
    }

    const currentApp = root.dataset.currentApp;
    const currentFinish = root.dataset.currentFinish;
    const currentHandle = root.dataset.currentHandle;

    const els = {
      apps: root.querySelector('[data-mp-apps]'),
      finishes: root.querySelector('[data-mp-finishes]')
    };

    /* Applications */
    const appMap = new Map();
    POWDERS.forEach(p => { if (!appMap.has(p.application)) appMap.set(p.application, p.appOrder); });
    const apps = [...appMap.entries()].sort((a, b) => a[1] - b[1]).map(e => e[0]);

    els.apps.innerHTML = apps.map(app => {
      const isCurrent = app === currentApp;
      const cls = isCurrent ? 'mp-nav-btn is-selected' : 'mp-nav-btn';
      return `<button type="button" class="${cls}" data-app="${esc(app)}"
              ${isCurrent ? 'aria-current="true"' : ''}>${esc(app)}</button>`;
    }).join('');

    /* Finishes */
    const validFinishes = new Set(
      POWDERS.filter(p => p.application === currentApp).map(p => p.finish)
    );
    els.finishes.innerHTML = FINISH_ORDER.map(f => {
      const valid = validFinishes.has(f);
      const isCurrent = f === currentFinish;
      const cls = ['mp-nav-btn'];
      if (isCurrent) cls.push('is-selected');
      if (!valid) cls.push('is-unavailable');
      const dis = valid ? '' : 'disabled aria-disabled="true"';
      return `<button type="button" class="${cls.join(' ')}" data-finish="${esc(f)}" ${dis}
              ${isCurrent ? 'aria-current="true"' : ''}>${esc(f)}</button>`;
    }).join('');

    /* Click handlers — preventDefault + stopPropagation kritik */
    els.apps.addEventListener('click', e => {
      const btn = e.target.closest('[data-app]');
      if (!btn || btn.classList.contains('is-selected')) return;
      e.preventDefault();
      e.stopPropagation();

      const app = btn.dataset.app;
      let target = POWDERS.find(p => p.application === app && p.finish === currentFinish);
      if (!target) {
        const candidates = POWDERS.filter(p => p.application === app)
          .sort((a, b) => a.finishOrder - b.finishOrder);
        target = candidates[0];
      }
      if (target && target.handle !== currentHandle) {
        console.log(LOG, 'app clicked:', app, '→', target.url);
        ajaxSwap(target.url, true);
      }
    });

    els.finishes.addEventListener('click', e => {
      const btn = e.target.closest('[data-finish]:not([disabled])');
      if (!btn || btn.classList.contains('is-selected')) return;
      e.preventDefault();
      e.stopPropagation();

      const finish = btn.dataset.finish;
      const target = POWDERS.find(p => p.application === currentApp && p.finish === finish);
      if (target && target.handle !== currentHandle) {
        console.log(LOG, 'finish clicked:', finish, '→', target.url);
        ajaxSwap(target.url, true);
      }
    });
  }

  /* ---------- AJAX SECTION SWAP ---------- */
  async function ajaxSwap(targetUrl, pushHistory) {
    console.log(LOG, '── ajaxSwap START', targetUrl);

    if (currentAbort) currentAbort.abort();
    currentAbort = new AbortController();

    const oldSection = document.getElementById(MAIN_SECTION_ID);
    if (!oldSection) {
      console.warn(LOG, 'oldSection #' + MAIN_SECTION_ID + ' bulunamadı — fallback reload');
      window.location.href = targetUrl;
      return;
    }
    oldSection.classList.add('mp-loading');

    try {
      console.log(LOG, '1. fetch başlıyor');
      const res = await fetch(targetUrl, { signal: currentAbort.signal });
      console.log(LOG, '2. fetch response:', res.status, res.ok);
      if (!res.ok) throw new Error('HTTP ' + res.status);

      const html = await res.text();
      console.log(LOG, '3. HTML alındı, uzunluk:', html.length);

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newSection = doc.getElementById(MAIN_SECTION_ID);
      console.log(LOG, '4. newSection:', newSection);
      if (!newSection) throw new Error('newSection bulunamadı');

      if (doc.title) document.title = doc.title;
      const newDesc = doc.querySelector('meta[name="description"]');
      const oldDesc = document.querySelector('meta[name="description"]');
      if (newDesc && oldDesc) oldDesc.setAttribute('content', newDesc.getAttribute('content') || '');

      if (pushHistory) history.pushState({ mpAjax: true }, '', targetUrl);
      console.log(LOG, '5. URL güncellendi');

      oldSection.replaceWith(newSection);
      console.log(LOG, '6. section swap tamam');

      newSection.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: 'main', load: 'load' }
      }));
      console.log(LOG, '7. shopify:section:load dispatch edildi');

      initAll();
      console.log(LOG, '── ajaxSwap COMPLETE ✓');

    } catch (err) {
      if (err.name === 'AbortError') {
        console.log(LOG, 'fetch iptal edildi (yeni tıklama)');
        return;
      }
      console.error(LOG, 'AJAX swap FAIL — fallback window.location.href', err);
      window.location.href = targetUrl;
    } finally {
      const sec = document.getElementById(MAIN_SECTION_ID);
      if (sec) sec.classList.remove('mp-loading');
      currentAbort = null;
    }
  }

  /* ---------- POPSTATE ---------- */
  window.addEventListener('popstate', () => {
    if (!cachedPowders) return;
    const path = new URL(location.href).pathname;
    const isPowderUrl = cachedPowders.some(p => {
      try { return new URL(p.url, location.origin).pathname === path; }
      catch { return false; }
    });
    if (isPowderUrl) ajaxSwap(location.href, false);
    else window.location.reload();
  });

  /* ---------- HELPER ---------- */
  function esc(str) {
    return String(str ?? '').replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  /* ---------- BOOT ---------- */
  console.log(LOG, 'script yüklendi, readyState:', document.readyState);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => {
    console.log(LOG, 'shopify:section:load yakalandı, initAll çağrılıyor');
    initAll();
  });

  window.MahyaMineralPowderNav = { init: initAll, swap: ajaxSwap, repositionNav, tryReposition };
})();